<template>
  <v-navigation-drawer
      id="navId"
      :class="
      $vuetify.theme.dark
        ? 'theme_dark theme_dark_border'
        : 'theme_light theme_light_border'
    "
      v-model="drawer"
      :permanent="true"
      :width="navBarWidth"
      :mini-variant-width="miniNavBarWidth"
      :clipped="$vuetify.breakpoint.lgAndUp"
      :mini-variant.sync="miniDrawer"
      fixed
      :app="$vuetify.breakpoint.lgAndUp"
  >
    <v-list
        :class="(miniDrawer === true) ? 'drawer-menu-list__mini' : 'drawer-menu-list__full'"
        dense
    >
      <template v-for="item in items">
        <v-tooltip right :key="item.text">
          <template v-slot:activator="{ on }">
            <v-list-group
                v-if="item.children"
                :key="item.text"
                v-model="item.model"
                append-icon
                id="menuListGroup"
                :class="{ minified: miniDrawer }"
                class="drawer-menu-list-group"
            >
              <template v-slot:prependIcon>
                <div
                    style="width: 100%; display: flex; justify-content: center"
                    :class="{ 'mt-1': $vuetify.breakpoint.mdAndDown }"
                >
                  <v-icon
                      style="
                      margin-top: 8px !important;
                    "
                      :style="
                      miniDrawer
                        ? `font-size: ${item.fontSize}px;`
                        : `font-size: ${item.fontSize}px;`
                    "
                      medium
                      class="drawer-menu-list-group__icon"
                      :class="
                      $vuetify.theme.dark
                        ? item.model
                          ? 'iconColorClicked_dark'
                          : 'iconColorNotClicked_dark'
                        : item.model
                        ? 'iconColorClicked_light'
                        : 'iconColorClicked_dark'
                    "
                  >{{ item.icon }}
                  </v-icon
                  >
                </div>
              </template>

              <template v-slot:activator>
                <hr
                    v-if="!miniDrawer"
                    width="1"
                    style="margin-right: 6px; height: 20px;"
                    :color="$vuetify.theme.dark ? 'white' : 'primary'"
                />
                <v-list-item
                    style="height: 50px"
                    :class="
                    $vuetify.theme.dark ? 'drawer-menu-list-group-sub-item iconColor_dark' : 'drawer-menu-list-group-sub-item iconColor_light'
                  "
                >
                  <v-list-item-content>
                    <v-list-item-title
                        :class="getItemClass('text', item.clicked) + ' menu_text'"
                    >{{ item.text }}
                    </v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </template>
              <div v-for="(child, i) in item.children" :key="i">
                <v-tooltip
                    v-if="
                    child.text === 'Debugger' ? (!!isAdmin) : true
                  "
                    right
                    v-model="child.hovered"
                    :key="item.text"
                >
                  <template v-slot:activator="{ on }">
                    <v-hover v-slot="{ hover }">
                      <v-list-item
                          v-on="miniDrawer && !isMobileOrTablet ? on : 0"
                          :style="{height: '50px'}"
                          :class="
                          $vuetify.theme.dark && child.clicked
                            ? 'drawer-menu-list-item clicked_item_background_dark'
                            : child.clicked
                            ? 'drawer-menu-list-item clicked_item_background_light'
                            : 'drawer-menu-list-item'
                        "
                          @click="enterPage(child)"
                      >
                        <v-list-item-action
                            v-if="child.icon"
                            class="drawer-menu-list-group-sub-item-action"
                        >
                          <v-icon
                              v-if="child.text !== 'About'"
                              :style="
                              miniDrawer
                                ? `font-size: ${child.fontSize}px;`
                                : `font-size: ${child.fontSize}px;`
                            "
                              :class="getItemClass('icon', child.clicked)"
                          >{{ child.icon }}
                          </v-icon
                          >
                          <v-img
                              v-else-if="$vuetify.theme.dark"
                              :style="
                              miniDrawer
                                ? `font-size: ${child.fontSize}px;`
                                : `font-size: ${child.fontSize}px;`
                            "
                              height="21"
                              contain
                              src="/img/dynamic-src-images/icons/about-dark-13x20.svg"
                          ></v-img>
                          <v-img
                              v-else
                              :style="
                              miniDrawer
                                ? `font-size: ${child.fontSize}px;`
                                : `font-size: ${child.fontSize}px;`
                            "
                              height="21"
                              contain
                              src="/img/dynamic-src-images/icons/about-13x20.svg"
                          ></v-img>
                        </v-list-item-action>
                        <v-list-item-action
                            :class="miniDrawer ? 'drawer-menu-list-item-action__mini' : 'drawer-menu-list-item-action'">
                          <hr
                              v-if="!miniDrawer"
                              width="1"
                              style="height: 20px"
                              :color="
                              $vuetify.theme.dark
                                ? child.clicked
                                  ? 'primary'
                                  : 'white'
                                : 'primary'
                            "
                          />
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title
                              :class="
                              getItemClass('text', child.clicked) + ' menu_text'
                            "
                          >
                            <v-row style="margin-left: 0 !important;margin-right: 0 !important;">
                              <p class="mb-0">{{ child.text }}</p>
                              <v-icon
                                  v-if="child.external"
                                  :dark="hover"
                                  :src="child.link"
                                  max-width="33"
                                  x-small
                                  :color="
                                  hover
                                    ? 'rgb(128,128,128,0.8)'
                                    : 'rgb(128,128,128,0)'
                                "
                                  style="font-size: 10px !important;margin-left: 8px !important;"
                              >fas fa-external-link-alt
                              </v-icon
                              >
                            </v-row>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-hover>
                  </template>
                  <span>{{ child.text }}</span>
                </v-tooltip>
              </div>
            </v-list-group>

            <v-hover v-else v-slot="{ hover }">
              <v-list-item
                  v-on="miniDrawer && !isMobileOrTablet ? on : 0"
                  :style="
                  $vuetify.breakpoint.height < 630
                    ? 'height: 40px !important;'
                    : 'opacity:1; !important;'
                "
                  style="height: 50px"
                  :class="
                  $vuetify.theme.dark &&
                  (item.clicked || currentPagePath === item.link)
                    ? 'clicked_item_background_dark textColor_dark'
                    : item.clicked || currentPagePath === item.link
                    ? 'clicked_item_background_light textColor_light'
                    : ''
                "
                  :key="item.text"
                  @click="enterPage(item)"
              >
                <v-list-item-action
                    :class="miniDrawer ? 'drawer-menu-list-item-action__mini' : 'drawer-menu-list-item-action'"
                >
                  <v-icon
                      :class="getItemClass('icon', item.clicked)"
                      :style="'font-size: ' + item.fontSize + 'px;'"
                  >{{ item.icon }}
                  </v-icon
                  >
                </v-list-item-action>

                <v-list-item-action>
                  <hr
                      v-if="!miniDrawer"
                      width="1"
                      style="height: 20px"
                      :color="
                      $vuetify.theme.dark
                        ? item.clicked
                          ? 'primary'
                          : 'white'
                        : 'primary'
                    "
                      :class="`menu_item_bar ${miniDrawer ? 'drawer-menu-list-item-action__mini' : 'drawer-menu-list-item-action'}`"
                  />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                      :class="getItemClass('text', item.clicked) + ' menu_text'"
                  >
                    <v-row style="margin-left: 0 !important;margin-right: 0 !important;">
                      <p class="mb-0">{{ item.text }}</p>
                      <v-icon
                          v-if="item.external"
                          :dark="hover"
                          :src="item.link"
                          max-width="33"
                          x-small
                          :color="
                          hover ? 'rgb(128,128,128,0.8)' : 'rgb(128,128,128,0)'
                        "
                          style="font-size: 10px !important;margin-left: 8px !important;"
                      >fas fa-external-link-alt
                      </v-icon
                      >
                    </v-row>
                  </v-list-item-title>
                </v-list-item-content>
                <v-img
                    v-if="item.text === 'Price Watcher'"
                    style="position: absolute; right: 13px; bottom: 19px"
                    dark
                    max-width="33"
                    src="../assets/other-images/beta.png"
                ></v-img>
              </v-list-item>
            </v-hover>
          </template>
          <span>{{ item.text }}</span>
        </v-tooltip>
      </template>
    </v-list>
    <v-container
        v-if="!miniDrawer"
        class="pl-1 pb-0"
        :style="
        !getMiniDrawer ? 'opacity: 0' : 'opacity: 1; transition: opacity 1s'
      "
        style="position: fixed !important; text-align: center; color: #1c6e59"
        :class="
        $vuetify.breakpoint.lgAndUp
          ? 'bPadding4RightsM10'
          : 'bPadding4RightsM20'
      "
    >
      <p
          class="rightsText"
          :class="{
          'mb-0':
            $vuetify.breakpoint.height < $vuetify.breakpoint.width &&
            $vuetify.breakpoint.height < 500,
        }"
      >
        ©{{ currentYear }}
        <a
            class="hover-text-primary"
            style="color: #1c6e59"
            href="http://dealio.ai"
            target="_blank"
        >Dealio</a
        >
        v{{ appVersion }}
      </p>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import {mapGetters} from "vuex";
import {APP_STATE_SECTIONS} from "@/utilities/enums";

export default {
  created() {
    if (window.location.pathname === "/") {
      this.items[0].clicked = true;
    }
    this.uriClientHandler();
  },
  // mixins: [AudioPlayer],
  methods: {
    /**
     * Handle the Client string presence and modify/rebuild link paths
     * accordingly, Currently only History item (Analytics) required
     *
     * @param subDomain {string} - the subdomain string to refine the link for
     */
    uriClientHandler(subDomain = 'analytics') {
      const clientIdentifier = window?.location?.hostname.split('.').length > 2 ? window?.location?.hostname.split('.')[0] : null;
      // console.log('clientIdentifier', clientIdentifier);
      // console.log('window.location.hostname', window.location.hostname);
      let refinedURL = '';
      // const urlProtocol = window.location.protocol;
      if (!!clientIdentifier && (clientIdentifier.length > 0)) {
        // console.log('clientIdentifier', clientIdentifier);
        let refinedURLBuffer = window.location.hostname.split('.');
        refinedURLBuffer[0] = refinedURLBuffer[0].replace(clientIdentifier, `${subDomain}-${clientIdentifier}`);
        // console.log('refinedURLBuffer post replace', refinedURLBuffer);
        // refinedURL = `${urlProtocol}://${refinedURLBuffer.join('.')}/`;
        refinedURL = `https://${refinedURLBuffer.join('.')}/`;
      } else {
        // refinedURL = `${urlProtocol}://${subDomain}.${window.location.hostname}/`;
        refinedURL = `https://${subDomain}.${window.location.hostname}/`;
      }
      // console.log('refinedURL NavigationBar', refinedURL);
      /**  replace the navigation History item link with the constructed refinedURL **/
      const historyItemIndex = this.items.findIndex(item => item.text === 'BI & Analytics')
      if (historyItemIndex >= 0) {
        // console.log('this.items[historyItemIndex]', this.items[historyItemIndex]);
        this.items[historyItemIndex].link = refinedURL;
      }
    },
    emitMute() {
      this.$emit("mute");
    },
    enterPage(item) {
      item.external
          ? window.open(item.link, "_blank")
          : this.$router.push(item.link).catch((err) => {
          });
      this.$emit("toggle-drawer", false);
    },
    getItemClass(textOrIcon, clicked) {
      if (textOrIcon === "text") {
        if (this.$vuetify.theme.dark) {
          if (clicked) {
            return "textColorClicked_dark textColor_dark";
          } else {
            return "textColorNotClicked_dark textColor_dark";
          }
        } else {
          if (clicked) {
            return "textColorClicked_light textColor_light";
          } else {
            return "textColorNotClicked_light textColor_light";
          }
        }
      } else {
        if (this.$vuetify.theme.dark) {
          if (clicked) {
            return "iconColorClicked_dark iconColor_dark";
          } else {
            return "iconColorNotClicked_dark iconColor_dark";
          }
        } else {
          return "iconColor_light";
        }
      }
    },

    clickedFun(routUrl) {
      this.items.forEach(function (item) {
        if (!item.hasOwnProperty("children")) {
          item.clicked = item.link === routUrl;
        } else {
          item.children.forEach(function (child) {
            child.clicked = child.link === routUrl;
          });
        }
      });
    },
  },
  props: {
    currentPagePath: {
      type: String,
      default: "",
    },
    muted: {
      type: Boolean,
      default: false,
    },
    isMobileOrTablet: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    themeSwitch: {
      get() {
        return this.$vuetify.theme.dark;
      },
      set(v) {
        this.$parent.$parent.updatePWATheme(v);
        this.$parent.$parent.updateApplicationState({
          section: APP_STATE_SECTIONS.DARK,
          mutation: v,
        });
        this.$vuetify.theme.dark = v;
      },
    },
    miniNavBarWidth() {
      if (this.currentPagePath === "/analytics" || this.currentPagePath === "/")
        return 60;
      else return 61;
    },
    navBarWidth() {
      if (this.currentPagePath === "/") return 240;
      else return 241;
    },
    appVersion() {
      return process.env.PACKAGE_VERSION;
    },
    miniDrawer: {
      get() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return false;
          case "sm":
            return false;
          case "md":
            return false;
          case "lg":
            return !this.getMiniDrawer;
          case "xl":
            return !this.getMiniDrawer;
          default:
            return false;
        }
      },
      set() {
      },
    },
    drawer: {
      get() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return this.getMiniDrawer;
          case "sm":
            return this.getMiniDrawer;
          case "md":
            return this.getMiniDrawer;
          case "lg":
            return true;
          case "xl":
            return true;
          default:
            return true;
        }
      },
      set(val) {
        this.$store.commit("minifyNavDrawer", val);
      },
    },
    ...mapGetters(["getMiniDrawer"]),
    ...mapGetters(["isAdmin"]),
  },

  data: () => ({
    currentYear: new Date().getFullYear(),
    temporar: false,
    currentMiniDrawer: null,
    windowWidth: 0,
    dialog: false,
    clicked: {},
    items: [
      {
        icon: "icon-home-17x17",
        text: "Home",
        link: "/",
        clicked: false,
        fontSize: "17",
      },
      {
        icon: "icon-analytics-23x23",
        text: "Risk Insider",
        link: "/analytics",
        clicked: false,
        fontSize: "14",
      },
      {
        icon: "icon-price-guard-21x25",
        text: "Price Guard",
        link: "/price-guard",
        clicked: false,
        fontSize: "14",
      },
      {
        icon: "icon-trade-watcher-21x25",
        text: "Trade Watcher",
        link: "/trade-watcher",
        clicked: false,
        fontSize: "14",
      },
      {
        icon: "icon-applications-19x14",
        text: "Applications",
        link: "/applications",
        clicked: false,
        fontSize: "14",
      },
      {
        icon: "icon-configurations-19x19",
        text: "Configurations",
        link: "/configurations",
        clicked: false,
        fontSize: "19",
      },
      {
        icon: "icon-servers-18x18",
        text: "Servers",
        link: "/servers",
        clicked: false,
        fontSize: "18",
      },
      {
        icon: "icon-event-rules-17x19",
        text: "Event Rules",
        link: "/eventrules",
        clicked: false,
        fontSize: "19",
      },
      {
        icon: "fas fa-chart-bar",
        text: "Dashboard",
        link: "/dashboard",
        clicked: false,
        fontSize: "19",
      },
      {
        icon: "fas fa-chart-line",
        // icon1: "fa-solid fa-chart-area",
        // icon2: "fa-solid fa-dollar-sign",
        // doubleIcon: true,
        text: "Price Watcher",
        link: "/price-watcher",
        clicked: false,
        fontSize: "19",
      },
      {
        icon: "fa-solid fa-chart-pie",
        text: "BI & Analytics",
        external: true,
        link: "https://analytics.dealio.ai/",
        clicked: false,
        fontSize: "17",
      },
      {
        icon: "icon-more-17x17",
        text: "More",
        model: window.location.pathname === "/settings",
        clicked: false,
        fontSize: "18",
        children: [
          {
            icon: "fas fa-bug",
            fontSize: "15",
            text: "Debugger",
            link: "/debugger",
            clicked: false,
            hovered: false,
            rightPadding: "3",
            leftPadding: "16",
          },
          {
            icon: "icon-settings-17x17",
            fontSize: "17",
            text: "Settings",
            link: "/settings",
            clicked: false,
            hovered: false,
            rightPadding: "3",
            leftPadding: "16",
          },
          {
            icon: "icon-help-17x17",
            fontSize: "17",
            text: "Help",
            external: true,
            link: "https://dealio.ai/contact-us/",
            clicked: false,
            hovered: false,
            rightPadding: "2",
            leftPadding: "16",
          },
          {
            icon: "icon-about-dark-13x20",
            fontSize: "20",
            text: "About",
            external: true,
            link: "https://dealio.ai/about-us/",
            clicked: false,
            hovered: false,
            rightPadding: "7",
            leftPadding: "16",
          },
        ],
      },
    ],
  }),
  watch: {
    $route(val) {
      this.clickedFun(window.location.pathname);
    },
  },
};
</script>

<style scoped src="../css/utilities/navigation-bar.css"></style>

<style>
.switch_light .v-input--switch__track {
  color: lightgray !important;
}

.switch_primary_color .v-input--switch__thumb {
  color: #47bd96 !important;
  -webkit-transform: translate(20px) !important;
  transform: translate(20px) !important;
}

.switch_primary_color .v-input--switch__track {
  color: #47bd96 !important;
}

.switch_primary_color .v-input--selection-controls__ripple {
  -webkit-transform: translate(18px) !important;
  transform: translate(18px) !important;
  color: #47bd96 !important;
}

.switch_primary_color .v-icon {
  color: #47bd96 !important;
}

.switch_light .v-icon {
  color: #1c6e59 !important;
}

#menuListGroup .v-list-item {
  height: 50px !important;
}

.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 23px;
}

.v-navigation-drawer__border {
  width: 0;
}

.v-list-group__header__prepend-icon {
  margin-right: 16px !important;
}

.minified .v-list-group__header__prepend-icon {
  margin-right: 0 !important;
}
</style>
